export const API_KEY = "AIzaSyA28Q-mVdm9-GhIAZ_m_GYW9bBxDWg6mAY";

export default API_KEY;
